module.exports = __webpack_public_path__ + "img/asterisk.ca11676a.svg";